/*
 * @Author: wufan 
 * @Date: 2019-08-19 16:10:36 
 * @Last Modified by: wufan
 * @Last Modified time: 2019-10-10 16:20:16
 * 帮助中心-头部
 */

import React, { ReactElement, useState } from 'react';

import './Header.less';
import ServiceWXModal from '../util/ServiceWXModal';
import {
  withRouter
} from 'react-router-dom';
const Header: React.FC = (props: any) => {
  const [modal, setModal] = useState<null | ReactElement>(null)
  return (
    <div className="header">
      <div className="center clearfix">
        <div className="header-left fl">
          <div className="logo fl">
            <h1 className="site-name">小麦助教</h1>
            <a href="https://www.xiaomai5.com">
              <div className="img">

              </div>
            </a>
          </div>
          <div className="title fl">{props.history.location.pathname.indexOf("product_dynamic") == -1 ? "帮助中心" : "产品动态"}</div>
        </div>
        <div className="contact-service">
          <ServiceWXModal />
        </div>
      </div>
      { modal }
    </div>
  )
}

export default withRouter(Header);
